import AsyncStorage from "@react-native-async-storage/async-storage";
//-----------------------------------------
// Llave para utilizar funciones del storage
//----------------------------------------- 
const key = "authToken";

//----------------------
// Crea la sesion del usuario 
//----------------------
const storeToken = async (authToken) => {
  //--
  try {
    await AsyncStorage.setItem(key, authToken);
  } catch (error) {
    console.log("Error storing the auth token", error);
  }
};

//-----------------------------------------
//Sirve para guardar mas cosas en la sesión
//-----------------------------------------
const getToken = async () => {
  try {
    return await AsyncStorage.getItem(key);
  } catch (error) {
    console.log("Error getting the auth token", error);
  }
};

const getUser = async () => {
  const token = await getToken();
  return token 
};
//-----------------------------------------------------
//Elimina la sesión para salir de la cuenta de usuario
//-----------------------------------------------------
const removeToken = async () => {
  try {
    await AsyncStorage.removeItem(key);
  } catch (error) {
    console.log("Error removing the auth token", error);
  }
};

export default { getToken, getUser, removeToken, storeToken };
